import React, { ReactNode } from "react";
import { cn } from "../../general";

interface ReadOnlyFieldProps {
  label: string;
  value?: ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({
  label,
  value,
  icon,
  className,
}) => {
  const normalizedValue = typeof value === "string" ? value.trim() : value;
  const hasValue =
    normalizedValue !== undefined &&
    normalizedValue !== null &&
    normalizedValue !== "";
  const resolvedValue = hasValue ? normalizedValue : "-";
  const isElement = React.isValidElement(resolvedValue);

  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <span className="text-sm font-medium text-[#414651]">{label}</span>
      <div className="relative">
        <div
          className={cn(
            "flex min-h-[44px] items-center gap-2 rounded-lg border border-[#D5D7DA] bg-gray-50 px-3.5 py-2 text-sm text-[#181D27]",
            icon ? "pl-10" : ""
          )}
        >
          {icon && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
              {icon}
            </span>
          )}
          {isElement ? (
            resolvedValue
          ) : (
            <span className="truncate">{String(resolvedValue)}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyField;
export type { ReadOnlyFieldProps };
